import PropTypes from "prop-types";
import React from "react";
import GenericQuizCorrector from "../../GenericQuiz/corrector.js";
import QuestionResult from "../../GenericQuiz/question-result.js";
import { getTenseLabel, PRONOUNS } from "./data.js";

function Corrector(props) {
  return (
    <GenericQuizCorrector {...props} activityEndpoint="conjugation">
      {({ id, verb, tense, pronoun, ...questionProps }) => (
        <QuestionResult
          key={id}
          {...questionProps}
          question={
            verb.substring(0, 1).toUpperCase() +
            verb.substring(1) +
            ", " +
            getTenseLabel(tense).toLowerCase() +
            (pronoun || pronoun === 0 ? ", " + PRONOUNS[pronoun] : "") +
            " : "
          }
          // TODO : Build the good invalid answer (radical + termination)
        />
      )}
    </GenericQuizCorrector>
  );
}
Corrector.propTypes = {
  milestoneId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  from: PropTypes.string,
};

export default Corrector;
